<mat-form-field [appearance]="brick.appearance" class="w-100">
    <mat-label class="me-1 input-label">{{ brick.label | translate}}</mat-label>
    <mat-select [formControl]="formControl" [ngClass]="brick.tipsMessage.length > 0 ? 'withTipsMessage' : ''" [compareWith]="brick.compareFn">
        <mat-option *ngFor="let item of brick.itemList" [value]="item" 
          (onSelectionChange)="onSelectionChange($event, item)"
          class="font-form-select-option">
          {{getText(item)}}
        </mat-option>
    </mat-select>
    <app-me-tips-icon class="ms-1" *ngIf="brick.tipsMessage.length > 0" [tipsData]="tipsData"></app-me-tips-icon>
    <mat-error>{{ getErrorMessage() }}</mat-error>
</mat-form-field>